import config from "./config";

class RelatifService {


    public static GetRelatif() {
        return fetch(`${config.wsUrl}/api/relatif/GetRelatif`).then(resp => {
            return resp.text();
        })
    }

    public static SetRelatif(relatif: string) {
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", 'application/json');
        return fetch(`${config.wsUrl}/api/relatif/SetRelatif`, { method: "post", body: JSON.stringify({ Content: relatif, token: localStorage.getItem("AuthToken") }), headers: myHeaders })
    }
}

export default RelatifService;
